// @ts-nocheck
const es = {
  STUDENTS: 'estudiantes',
  CAN_ENROLL_TEMPORAL_ACCESS: 'Acceso temporal',
  CAN_ENROLL_FREEMIUM: 'Pruébalo ahora',
  CAN_ENROLL_MEMBERSHIP: 'Acceso Total',
  CAN_ENROLL_FREE: 'Gratis',
  CAN_ENROLL_PAID: 'Acceso Total',
  CAN_ENROLL_B2B: '',
};

export default es;
